import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
	selector: '[ahpOnEnter]',
})
export class OnEnterDirective {
	@Output('ahpOnEnter')
	public enter: EventEmitter<void> = new EventEmitter<void>();

	@HostListener('keydown', ['$event'])
	onKeydown($event: KeyboardEvent): void {
		// IE/Edge doesn't support code, so we check key as well
		if ($event.code?.toLowerCase() === 'enter' || $event.key?.toLowerCase() === 'enter') {
			this.enter.emit();
			$event.preventDefault();
			$event.stopPropagation();
		}
	}
}
